import { render, staticRenderFns } from "./flats-crm-btns.vue?vue&type=template&id=fa8a1b5c&"
import script from "./flats-crm-btns.vue?vue&type=script&lang=js&"
export * from "./flats-crm-btns.vue?vue&type=script&lang=js&"
import style0 from "./flats-crm-btns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports